import { render, staticRenderFns } from "./PanelKolInfo.vue?vue&type=template&id=58303c9e&scoped=true"
import script from "./PanelKolInfo.vue?vue&type=script&lang=js"
export * from "./PanelKolInfo.vue?vue&type=script&lang=js"
import style0 from "./PanelKolInfo.vue?vue&type=style&index=0&id=58303c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58303c9e",
  null
  
)

export default component.exports